import { createTheme } from "@mui/material";
import * as index from "./styles/typography/index.js";
const typography = {
  ...index,
  fontFamily: ["Ultramarine", "DM Sans"].join(",")
};
const createAscendTheme = ({
  tokens,
  name
}) => {
  const breakpointsValues = {
    values: {
      xxs: parseFloat(tokens.breakpointXxs),
      xs: parseFloat(tokens.breakpointXs),
      sm: parseFloat(tokens.breakpointSm),
      md: parseFloat(tokens.breakpointMd),
      lg: parseFloat(tokens.breakpointLg),
      xl: parseFloat(tokens.breakpointXl),
      xxl: parseFloat(tokens.breakpointXxl)
    }
  };
  const {
    breakpoints,
    spacing
  } = createTheme({
    breakpoints: breakpointsValues,
    spacing: 4
  });
  return {
    // a conditional that is used to eject from Ascend components
    useVanillaMui: false,
    // ascend tokens
    ascend: {
      colors: {
        // primitive
        neutral: {
          "0": tokens.colorNeutral0,
          "25": tokens.colorNeutral25,
          "50": tokens.colorNeutral50,
          "75": tokens.colorNeutral75,
          "150": tokens.colorNeutral150,
          "300": tokens.colorNeutral300,
          "500": tokens.colorNeutral500,
          "600": tokens.colorNeutral600,
          "700": tokens.colorNeutral700,
          "800": tokens.colorNeutral800,
          "900": tokens.colorNeutral900,
          "950": tokens.colorNeutral950,
          "975": tokens.colorNeutral975
        },
        blue: {
          "25": tokens.colorBlue25,
          "50": tokens.colorBlue50,
          "100": tokens.colorBlue100,
          "200": tokens.colorBlue200,
          "300": tokens.colorBlue300,
          "400": tokens.colorBlue400,
          "500": tokens.colorBlue500,
          "600": tokens.colorBlue600,
          "800": tokens.colorBlue800
        },
        sky: {
          "25": tokens.colorSky25,
          "50": tokens.colorSky50,
          "100": tokens.colorSky100,
          "200": tokens.colorSky200,
          "300": tokens.colorSky300,
          "400": tokens.colorSky400,
          "600": tokens.colorSky600,
          "800": tokens.colorSky800
        },
        red: {
          "25": tokens.colorRed25,
          "50": tokens.colorRed50,
          "100": tokens.colorRed100,
          "200": tokens.colorRed200,
          "300": tokens.colorRed300,
          "400": tokens.colorRed400,
          "600": tokens.colorRed600,
          "800": tokens.colorRed800
        },
        orange: {
          "25": tokens.colorOrange25,
          "50": tokens.colorOrange50,
          "100": tokens.colorOrange100,
          "200": tokens.colorOrange200,
          "300": tokens.colorOrange300,
          "400": tokens.colorOrange400,
          "600": tokens.colorOrange600,
          "800": tokens.colorOrange800
        },
        yellow: {
          "25": tokens.colorYellow25,
          "50": tokens.colorYellow50,
          "100": tokens.colorYellow100,
          "200": tokens.colorYellow200,
          "300": tokens.colorYellow300,
          "400": tokens.colorYellow400,
          "600": tokens.colorYellow600,
          "800": tokens.colorYellow800
        },
        green: {
          "25": tokens.colorGreen25,
          "50": tokens.colorGreen50,
          "100": tokens.colorGreen100,
          "200": tokens.colorGreen200,
          "300": tokens.colorGreen300,
          "400": tokens.colorGreen400,
          "600": tokens.colorGreen600,
          "800": tokens.colorGreen800
        },
        purple: {
          "25": tokens.colorPurple25,
          "50": tokens.colorPurple50,
          "100": tokens.colorPurple100,
          "200": tokens.colorPurple200,
          "300": tokens.colorPurple300,
          "400": tokens.colorPurple400,
          "600": tokens.colorPurple600,
          "800": tokens.colorPurple800
        },
        grassGreen: {
          "25": tokens.colorGrassGreen25,
          "50": tokens.colorGrassGreen50,
          "100": tokens.colorGrassGreen100,
          "200": tokens.colorGrassGreen200,
          "300": tokens.colorGrassGreen300,
          "400": tokens.colorGrassGreen400,
          "600": tokens.colorGrassGreen600,
          "800": tokens.colorGrassGreen800
        },
        // alias
        background: {
          primary: tokens.colorBackgroundPrimary,
          secondary: tokens.colorBackgroundSecondary,
          accent: tokens.colorBackgroundAccent,
          accentLight: tokens.colorBackgroundAccentLight,
          red: tokens.colorBackgroundRed,
          orange: tokens.colorBackgroundOrange,
          yellow: tokens.colorBackgroundYellow,
          green: tokens.colorBackgroundGreen,
          blue: tokens.colorBackgroundBlue,
          sky: tokens.colorBackgroundSky,
          purple: tokens.colorBackgroundPurple,
          informational: tokens.colorBackgroundInformational,
          positive: tokens.colorBackgroundPositive,
          warning: tokens.colorBackgroundWarning,
          negative: tokens.colorBackgroundNegative,
          state: {
            disabled: tokens.colorBackgroundStateDisabled,
            accentHover: tokens.colorBackgroundStateAccentHover
          },
          inverse: {
            inversePrimary: tokens.colorBackgroundInversePrimary
          }
        },
        content: {
          primary: tokens.colorContentPrimary,
          secondary: tokens.colorContentSecondary,
          accent: tokens.colorContentAccent,
          informational: tokens.colorContentInformational,
          positive: tokens.colorContentPositive,
          warning: tokens.colorContentWarning,
          negative: tokens.colorContentNegative,
          state: {
            disabled: tokens.colorContentStateDisabled,
            accentHover: tokens.colorContentStateAccentHover,
            primaryHover: tokens.colorContentStatePrimaryHover
          },
          inverse: {
            inversePrimary: tokens.colorContentInversePrimary
          }
        },
        border: {
          primary: tokens.colorBorderPrimary,
          accent: tokens.colorBorderAccent,
          opaque: tokens.colorBorderOpaque,
          selected: tokens.colorBorderSelected,
          negative: tokens.colorBorderNegative,
          state: {
            accentHover: tokens.colorBorderStateAccentHover,
            disabled: tokens.colorBorderStateDisabled,
            primaryHover: tokens.colorBorderStatePrimaryHover
          }
        }
      },
      radius: {
        xs: "0px",
        sm: "4px",
        md: "8px",
        lg: "50%"
      },
      shadows: {
        0: "none",
        1: "0px 0.5px 2.5px 0px rgba(29, 37, 47, 0.05), 0px 0.5px 0.7px 0px rgba(20, 46, 87, 0.07)",
        2: "0px 1px 3.3px 0px rgba(29, 37, 47, 0.10), 0px 0.13px 0.3px 0px rgba(20, 46, 87, 0.01)",
        3: "0px 2.5px 7px 0px rgba(29, 37, 47, 0.06), 0px 1px 1.8px 0px rgba(29, 37, 47, 0.01), 0px 0.3px 1.5px 0px rgba(20, 46, 87, 0.03)",
        4: "0px 5px 13px 0px rgba(29, 37, 47, 0.10), 0px 2px 5px 0px rgba(29, 37, 47, 0.02), 0px 0.5px 1.3px 0px rgba(20, 46, 87, 0.02)",
        5: "0px 10px 28px 0px rgba(29, 37, 47, 0.10), 0px 4px 10px 0px rgba(29, 37, 47, 0.05), 0px 1px 3px 0px rgba(20, 46, 87, 0.03)",
        6: "0px 19px 53px 0px rgba(29, 37, 47, 0.10), 0px 8px 20px 0px rgba(29, 37, 47, 0.07), 0px 2px 5px 0px rgba(20, 46, 87, 0.05)",
        7: "0px 27px 74px 0px rgba(29, 37, 47, 0.10), 0px 13px 32px 0px rgba(29, 37, 47, 0.08), 0px 3px 7px 0px rgba(20, 46, 87, 0.05)"
      },
      spacing,
      typography
    },
    // -------- mui theme overrides below --------
    breakpoints,
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            ...typography.bodyMd
          }
        }
      }
    },
    name,
    palette: {
      primary: {
        main: tokens.colorContentAccent,
        light: tokens.colorBackgroundAccentLight,
        dark: tokens.colorBackgroundStateAccentHover
      },
      error: {
        main: tokens.colorContentNegative,
        light: tokens.colorBackgroundNegative
      },
      warning: {
        main: tokens.colorContentWarning,
        light: tokens.colorBackgroundWarning
      },
      success: {
        main: tokens.colorContentPositive,
        light: tokens.colorBackgroundPositive
      },
      grey: {
        100: tokens.colorNeutral25,
        200: tokens.colorNeutral50,
        300: tokens.colorNeutral75,
        400: tokens.colorNeutral150,
        500: tokens.colorNeutral300,
        600: tokens.colorNeutral500,
        700: tokens.colorNeutral700,
        800: tokens.colorNeutral800,
        900: tokens.colorNeutral900
      },
      text: {
        primary: tokens.colorContentPrimary
      }
    },
    typography
  };
};
export {
  createAscendTheme
};
//# sourceMappingURL=createAscendTheme.js.map
